<template>
	<CampaignLayout :subtitle="trans('tools.campaigns.send.associates')" :campaign="campaign">
		<template #actions>
			<PrimaryButton :color="Color.Green" @click.stop="send">
				<i class="fa-solid fa-paper-plane mr-2"/>
				{{ trans('general.send') }}
			</PrimaryButton>
		</template>
		<SearchModel attribute="full_name" :label="trans('general.search')" search-type="users" no-grow relative @selected="add"/>
		<div class="flex flex-wrap gap-3">
			<div v-for="user in selectedUsers" :key="`user-${user.id}`" class="px-2 py-1 rounded border border-gray-200 dark:border-gray-800 flex items-center gap-2 flex-nowrap whitespace-nowrap text-sm">
				{{ user.full_name }}
				<CloseButton @close="remove(user)"/>
			</div>
		</div>
	</CampaignLayout>
</template>
<script setup lang="ts">
import axios from 'axios'
import {route} from 'ziggy-js'
import {trans} from 'laravel-vue-i18n'
import {type User} from '@/Types/User'
import {Color} from '@/Types/Enums/Color'
import {defineProps, type Ref, ref} from 'vue'
import CampaignLayout from '@/Layouts/CampaignLayout.vue'
import SearchModel from '@/Components/Search/SearchModel.vue'
import {type Campaign} from '@/Types/Tools/Campaigns/Campaign'
import CloseButton from '@/Components/UI/Buttons/CloseButton.vue'
import PrimaryButton from '@/Components/UI/Buttons/PrimaryButton.vue'
import {showInfo, showSuccess, showValidationErrors, showWarning} from '@/Helpers/general'

const props = defineProps<{
	campaign:Campaign,
}>()

const working:Ref<boolean> = ref(false)
const campaign:Ref<Campaign> = ref(props.campaign)
const selectedUsers:Ref<Array<User>> = ref([])

function add(user:User):void{
	const index:number = selectedUsers.value.findIndex((s:User) => s.id === user.id)
	if(index === -1){
		selectedUsers.value.push(user)
	}
}

function remove(user:User):void{
	const index:number = selectedUsers.value.findIndex((s:User) => s.id === user.id)
	if(index > -1){
		selectedUsers.value.splice(index, 1)
	}
}

function send():void{
	if(selectedUsers.value.length === 0){
		showWarning(trans('general.selected.empty'))
	} else if(!working.value){
		working.value = true
		showInfo(trans('tools.campaigns.mails.sending'))
		axios.post(route('tools.campaigns.send.associates.store', campaign.value.id), {
			selected: selectedUsers.value,
		}).then(() => {
			showSuccess(trans('tools.campaigns.mails.sent'))
		}).catch(showValidationErrors).finally(() => {
			working.value = false
		})
	}
}
</script>
